import { z } from "zod";
import {
  SubscriptionTier,
  SubscriptionStatus,
} from "../schemas/SubscriptionSchema";
export const BillingActionUnavailableReasonSchema = z.enum([
  "ROLE_REQUIRED",
  "ACCOUNT_UNRECOGNIZED",
  "SUBSCRIPTION_EXISTS",
  "BILLING_UNAVAILABLE",
  "PRICE_UNAVAILABLE",
  "CHECKOUT_IN_PROGRESS",
  "RECONCILIATION_REQUIRED",
  "CUSTOMER_REQUIRED",
]);
export const BillingActionAvailabilitySchema = z.discriminatedUnion(
  "available",
  [
    z.object({ available: z.literal(true) }).strict(),
    z
      .object({
        available: z.literal(false),
        reason: BillingActionUnavailableReasonSchema,
      })
      .strict(),
  ],
);
export const BillingAccountSubscriptionStatusSchema = z.discriminatedUnion(
  "kind",
  [
    z.object({ kind: z.literal("KNOWN"), value: SubscriptionStatus }).strict(),
    z.object({ kind: z.literal("UNRECOGNIZED") }).strict(),
  ],
);
export const BillingAccountSubscriptionSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("NONE") }).strict(),
  z
    .object({
      kind: z.literal("KNOWN"),
      tier: SubscriptionTier,
      status: BillingAccountSubscriptionStatusSchema,
      currentPeriodEnd: z.string().datetime().nullable(),
      cancelAtPeriodEnd: z.boolean().nullable(),
    })
    .strict(),
  z.object({ kind: z.literal("UNRECOGNIZED") }).strict(),
]);
export const BillingAccountSchema = z
  .object({
    tenantId: z.string().regex(/^[A-Za-z0-9_-]{1,128}$/),
    revision: z.string().regex(/^[a-f0-9]{64}$/),
    subscription: BillingAccountSubscriptionSchema,
    actions: z
      .object({
        checkout: z
          .object({
            STARTUP: BillingActionAvailabilitySchema,
            SCALEUP: BillingActionAvailabilitySchema,
          })
          .strict(),
        portal: BillingActionAvailabilitySchema,
      })
      .strict(),
  })
  .strict()
  .superRefine((value, context) => {
    const subscription = value.subscription;
    if (
      (subscription.kind === "UNRECOGNIZED" ||
        (subscription.kind === "KNOWN" &&
          (subscription.tier !== "FREE" ||
            subscription.status.kind === "UNRECOGNIZED"))) &&
      (value.actions.checkout.STARTUP.available ||
        value.actions.checkout.SCALEUP.available)
    )
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["actions", "checkout"],
        message: "Checkout availability contradicts account state",
      });
  });
export type BillingAccount = z.infer<typeof BillingAccountSchema>;
export type BillingActionAvailability = z.infer<
  typeof BillingActionAvailabilitySchema
>;
export type BillingActionUnavailableReason = z.infer<
  typeof BillingActionUnavailableReasonSchema
>;
